import { useThemeColors } from '@/shared/theme/useThemeColors';
import { semantic, typography } from '@/shared/theme/tokens';

/**
 * Branded "we're down" fallback UI (AUT-180). Presentational only — used by both
 * the router errorElement (ErrorPage) and the top-level ErrorBoundary.
 */
export function ErrorFallback({ onRetry }) {
  const c = useThemeColors();

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ background: c.bgPage, fontFamily: typography.fontFamily.body }}
    >
      <div className="text-center max-w-sm px-4">
        <span
          className="material-symbols-outlined text-[64px] text-error mb-4 block"
          style={{ fontVariationSettings: "'FILL' 0" }}
        >
          cloud_off
        </span>
        <h1
          className="text-2xl font-bold text-on-surface mb-2"
          style={{ fontFamily: typography.fontFamily.heading }}
        >
          We&apos;re temporarily down
        </h1>
        <p className="text-sm text-on-surface-variant mb-6">
          Something went wrong on our end. Please check again in a little while —
          if it keeps happening, contact your administrator.
        </p>
        <button
          onClick={onRetry ?? (() => window.location.reload())}
          className="text-on-primary rounded-lg px-6 py-2.5 text-xs font-semibold tracking-widest uppercase inline-flex items-center gap-2"
          style={{ background: semantic.brandGrad }}
        >
          <span className="material-symbols-outlined text-[16px]">refresh</span>
          Try again
        </button>
      </div>
    </div>
  );
}
